import { xBaseTheme } from "@guestsupply/XDL/types";

export default {
    keys: ["xs", "sm", "md", "lg", "xl"],
    values: [0, 481, 768, 1025, 1366],
    maxWidths: [480, 767, 1024, 1366, 1366],
    containerPadding: ["0 16px", "0 16px", "0 16px", "0 16px", "0 16px"],
} as xBaseTheme["breakpoints"];
